<template>
    <div>
        <el-table
                :data="list"
                style="width: 100%">
            <el-table-column
                    prop="task_sn"
                    label="订单编号"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="create_time"
                    label="创建时间"
                    width="140">
            </el-table-column>
            <el-table-column
                    prop="type_name"
                    label="推广类型"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="task_price"
                    label="推广金额"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="task_title"
                    label="推广标题">
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="150">
                <template slot-scope="scope">
<!--                    <el-button @click="handleCancel(scope.row.id,scope.row.xcmini_enterprise_user.user_id)" size="small" v-if="scope.row.cancel_sign == '1'">取消</el-button>-->
<!--                    <el-button @click="handleCancel(scope.row.id)" size="small" v-if="scope.row.cancel_sign == '0'" disabled>取消</el-button>-->
                    <el-button @click="handleEdit(scope.row.id,scope.row.type,scope.row.user_id)" size="small">编辑</el-button>
                    <el-button @click="handleClick(scope.row.id)" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pages">
            <el-pagination
                    @current-change="current_change"
                    :current-page.sync="page"
                    :page-size="10"
                    layout="prev, pager, next, jumper"
                    :total="orderTotal"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        inject:['getOrder'],
        name: 'agentTab1',
        data(){
            return{
                page:this.currentPage
            }
        },
        props: {
            list: Array,
            orderTotal: Number,
            currentPage:Number
        },
        methods: {
            current_change (currentPage) {
                // 页码
                this.currentPage = currentPage;
                this.$emit('changCurrent',currentPage);
                // 调用父组件方法
                this.getOrder();
            },
            handleEdit (id,type,user_id) {
                if (type == 1) {
                    this.$router.push({path:'/daren/edit'+'?id='+id + '&ep_id=' + user_id})
                } else if (type == 0 ) {
                    this.$alert('该任务是在小程序端发布的，请前往小程序端编辑', '提示', {
                        confirmButtonText: '确定'
                    });
                }
            },
            handleCancel (id,user_id) {
                this.$emit('func',id,user_id)
            },
            handleClick (id) {
                this.$router.push({path:'/daren/agentDetail'+'?id='+id})
            }
        }
    }
</script>
<style scoped></style>
